import { Coins, Zap } from 'lucide-react';

interface BalanceCardProps {
  coins: string | number;
  energy: number;
  maxEnergy?: number;
}

export const BalanceCard = ({ coins, energy, maxEnergy = 100 }: BalanceCardProps) => {
  const numericCoins = Number(coins);
  const formattedCoins = Number.isFinite(numericCoins)
    ? numericCoins.toLocaleString()
    : coins.toString();

  const energyPercent = Math.min(100, Math.max(0, (energy / maxEnergy) * 100));

  return (
    <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-primary/20 to-secondary/20 p-4 shadow-lg">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/20">
            <Coins className="h-7 w-7 text-primary" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wide text-white/60">Coins</div>
            <div className="text-lg font-bold text-white">{formattedCoins}</div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/20">
            <Zap className="h-7 w-7 text-primary" />
          </div>
          <div className="flex-1">
            <div className="text-xs uppercase tracking-wide text-white/60">Energy</div>
            <div className="text-lg font-bold text-white">
              {energy}/{maxEnergy}
            </div>
            <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-white/10">
              <div
                className="h-full rounded-full bg-gradient-to-r from-primary to-secondary transition-all"
                style={{ width: `${energyPercent}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
